import { createSelector } from 'reselect';

export const selectStateUser = () => state => state.user;

export const selectUser = () =>
  createSelector(
    selectStateUser(),
    stateUser => stateUser.user
  );
